import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { FeeRule } from '@/lib/parts-financial/calculator';

export interface ShopFeeRuleRow extends FeeRule {
  id: string;
  shop_id: string;
}

export function useShopFeeRules(shopId: string | null | undefined) {
  return useQuery({
    queryKey: ['shop_fee_rules', shopId],
    enabled: !!shopId,
    queryFn: async (): Promise<ShopFeeRuleRow[]> => {
      const { data, error } = await supabase
        .from('shop_fee_rules' as any)
        .select('*')
        .eq('shop_id', shopId!)
        .order('created_at', { ascending: true });
      if (error) throw error;
      return (data || []) as unknown as ShopFeeRuleRow[];
    },
  });
}
